import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  public loading = new BehaviorSubject(false);

  setLoading(isLoading: boolean): void {
    // Deferred to a microtask so a synchronous setLoading() call made while another
    // component is still initializing (e.g. during ngOnInit right after navigation)
    // lands in its own change-detection cycle, instead of mutating LoadingComponent's
    // state in between Angular's check and checkNoChanges passes of the current one
    // (which is what throws NG0100: ExpressionChangedAfterItHasBeenCheckedError).
    Promise.resolve().then(() => this.loading.next(isLoading));
  }

  isLoading(): boolean {
    return this.loading.value;
  }
}
